import { X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { useTranslation } from '@tankef/i18n';
import { Drawer, Logo, NavSection, IconButton } from '@tankef/ui';
import type { NavItemData } from '@tankef/ui';

import { useNavData } from '../config-nav';

interface NavMobileProps {
  isOpen: boolean;
  onClose: () => void;
}

export function NavMobile({ isOpen, onClose }: NavMobileProps) {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navData = useNavData();

  const renderNavLink = ({
    item,
    children,
    className,
    onClick,
  }: {
    item: NavItemData;
    children: React.ReactNode;
    className: string;
    onClick?: () => void;
  }) => {
    const tourAttr =
      item.key === 'wallet'
        ? 'nav-wallet'
        : item.key === 'investments'
          ? 'nav-investments'
          : item.key === 'savings-box'
            ? 'nav-savings'
            : undefined;

    return (
      <Link to={item.path || '#'} className={className} onClick={onClick} data-tour={tourAttr}>
        {children}
      </Link>
    );
  };

  return (
    <Drawer isOpen={isOpen} onClose={onClose} position="left" size="md">
      <div className="flex h-full flex-col">
        {/* Header */}
        <div className="flex h-16 items-center justify-between border-b border-tkf-line-light px-4">
          <Link to="/dashboard" onClick={onClose}>
            <Logo disableLink />
          </Link>
          <IconButton
            variant="ghost"
            size="sm"
            onClick={onClose}
            aria-label={t('toolbar.closeMenu')}
          >
            <X className="h-5 w-5" />
          </IconButton>
        </div>

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto p-3">
          <NavSection
            data={navData}
            activeKey={location.pathname}
            renderLink={renderNavLink}
            onItemClick={onClose}
          />
        </div>
      </div>
    </Drawer>
  );
}
